import { CSSProperties } from "react"

import { AccordionContent, AccordionItem, AccordionRoot, AccordionTrigger, cn } from "../../ui"

interface AccordionStyle extends CSSProperties {
    ["--text-color"]: string
    ["--bg-color"]: string
}

export const Accordion = ({
    textColor,
    bgColor,
    title,
    content,
    value,
}: {
    textColor: string
    bgColor: string
    title: JSX.Element
    content: JSX.Element
    value: string
}) => {
    const style: AccordionStyle = {
        ["--text-color"]: textColor,
        ["--bg-color"]: bgColor,
    }
    return (
        <div
            style={style}
            className={cn("px-4 text-[var(--text-color)]", bgColor ? "bg-[var(--bg-color)]" : "bg-gray-bg")}>
            <AccordionRoot type="single" collapsible>
                <AccordionItem value={value}>
                    <AccordionTrigger className="flex cursor-pointer items-center justify-between border-b py-4 transition-all duration-300 data-[state=open]:border-b-gray-activeTitle data-[state=closed]:border-b-transparent">
                        {title}
                    </AccordionTrigger>
                    <AccordionContent className="py-4">{content}</AccordionContent>
                </AccordionItem>
            </AccordionRoot>
        </div>
    )
}
